import { gql } from "apollo-boost";

export const GET_ETSY_LISTING_STATS_BY_STORE = gql`
    query GetEtsyListingStatsByStore($filter: GetEtsyListingStatsFilter!) {
        getEtsyListingStatsByStore(filter: $filter) {
            updatedAt
            currency
            store {
                id
            }
            data {
                id
                listingId
                listingName
                imageLink
                views
                favorites
                orders
                revenue
                status
                ads {
                    listingId
                    isPromoted
                    impressionCount
                    clickCount
                    clickRate
                    conversions
                    revenue
                    spentTotal
                    roas
                }
                agg {
                    trueRoas
                    adsPercentage
                }
            }
        }
    }
`;

export const GET_ETSY_METRIC_STORES = gql`
    query getEtsyMetricStores($filter: StoreFilter!) {
        stores(filter: $filter) {
            total
            nodes {
                id
                title
            }
        }
    }
`;

export const GET_ETSY_METRICS = gql`
    query getEtsyMetrics($filter: GetEtsyMetricsFilter!) {
        getEtsyMetricByStore(filter: $filter) {
            updatedAt
            store {
                id
                title
            }
            data {
                type
                total
                currency
                entries {
                    date
                    value
                }
            }
        }
    }
`;
export const GET_ETSY_LISTING_ADS_BY_STORE = gql`
    query getEtsyListingAdsByStore($filter: GetEtsyListingAdsFilter!) {
        getEtsyListingAdsByStore(filter: $filter) {
            store {
                id
            }
            data {
                spentTotal
                clickCount
            }
        }
    }
`;
